import { createStyles, Theme, withStyles } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import SvgIcon from '@material-ui/core/SvgIcon';
import * as React from 'react';
import Sidebar from 'react-sidebar';
import { SlidePanelContent, SlidePanelPosition, SlidePanelSide } from '../../../store/types';
import { FiltersContainer } from '../../filters';
import { MediaInfoContainer } from '../../timeline/mediaInfo/MediaInfoContainer';

export interface SidePanelProps {
  position: SlidePanelPosition;
  content: SlidePanelContent;
  side: SlidePanelSide;
}

export interface SidePanelActions {
  closePanel: () => void;
}

interface StylesProps {
  classes: {
    chevron: string;
    label: string;
  };
}

const styles = (theme: Theme) =>
  createStyles({
    chevron: {
      padding: '4px',
      margin: '16px',
      position: 'absolute',
      top: 0,
      right: 0
    }
  });

class SidePanel extends React.PureComponent<SidePanelProps & SidePanelActions & StylesProps> {
  private getContent = (): JSX.Element | null => {
    switch (this.props.content) {
      case SlidePanelContent.MediaInfo:
        return <MediaInfoContainer />;
      case SlidePanelContent.Filters:
        return <FiltersContainer />;
      case SlidePanelContent.Empty:
      default:
        return null;
    }
  };

  private onSetSidebarOpen(open: boolean) {}

  public render = () => (
    <Sidebar
      pullRight={this.props.side === SlidePanelSide.Right}
      sidebar={
        <div>
          <IconButton onClick={this.props.closePanel} className={this.props.classes.chevron}>
            <SvgIcon>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24">
                <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                <path d="M0 0h24v24H0z" fill="none" />
              </svg>
            </SvgIcon>
          </IconButton>
          {this.getContent()}
        </div>
      }
      onSetOpen={this.onSetSidebarOpen}
      open={this.props.position === SlidePanelPosition.Opened}
      docked={this.props.position === SlidePanelPosition.Docked}
      styles={{ sidebar: { background: 'white' } }}
    >
      {this.props.children}
    </Sidebar>
  );
}

export default withStyles(styles)(SidePanel);



// WEBPACK FOOTER //
// ./src/components/common/sidePanel/SidePanel.tsx